
import { BaseMessage } from './base-message';

export class Information extends BaseMessage {
    override get type(): string {
        return 'information';
    }
}
